import React, { useEffect, useState, useContext } from 'react';
import { UserContext } from '../../contexts/userContext';
import MachineSelect from '../report/MachineSelect';
import request from '../../../services/Request';
import LoadingIcon from '../../items/buttons/LoadingIcon';
import BackButton from '../../items/buttons/BackButton';
import { userLimits } from '../uitls/userLimits';
import ModernTable, { ModernPageContainer, ModernPageHeader } from '../components/ModernTable';
import { localDateRange } from '../../../services/method/methods';
import moment from 'moment';
import { Grid, Container, Box, Typography, Chip, alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DevicesIcon from '@mui/icons-material/Devices';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import ComputerIcon from '@mui/icons-material/Computer';
import ErrorIcon from '@mui/icons-material/Error';
import PersonIcon from '@mui/icons-material/Person';
import CategoryIcon from '@mui/icons-material/Category';
const getGroupsURL = `/groupsAndMachinesForReport/`;
const getAlerts = `/logs/getKioskLog`;

export default function KioskLog(props) {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user'));
  const NotBothAdmin = user.role == 'SuperAdmin' || user.role === 'BoxAdmin' ? true : false;
  var date = new Date();
  const [machines, setMachines] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groupV, setgroupV] = useState([]);
  const [radio, setRadio] = useState('a');
  const [loading, setLoading] = useState(true);

  const [data, setData] = useState([]);
  const [startDate, setStartDate] = useState(new Date(date.getFullYear(), date.getMonth(), 1));
  const [endDate, setEndDate] = useState(new Date());

  const [machinesName, setmachinesName] = useState('All Machines');

  const [pagination, setPagination] = useState(
    localStorage.getItem('table_view_kiosk') ? localStorage.getItem('table_view_kiosk') : 20
  );

  useEffect(() => {
    localStorage.setItem('table_view_kiosk', pagination);
  }, [pagination]);

  const { userEmail, setFiltered, filterd } = useContext(UserContext);
  const { id, tableTitle, superAdmin } = userLimits(
    props.match.params.id,
    props.match.params.group,
    'Kiosk Logs',
    'view_report'
  );

  const columns = [
    {
      title: 'Time',
      field: 'localTime',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
          {moment.utc(new Date(rowData.localTime)).format('lll')}
        </Typography>
      ),
    },
    {
      title: 'Machine',
      field: 'machineID.name',
      render: (rowData) => (
        <Chip
          label={rowData.machineID?.name}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.info.main, 0.12),
            color: theme.palette.info.dark,
            border: `1.5px solid ${alpha(theme.palette.info.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Type',
      field: 'type',
      render: (rowData) => (
        <Chip
          label={rowData.type}
          size="small"
          sx={{
            fontWeight: 600,
            backgroundColor: alpha(theme.palette.primary.main, 0.12),
            color: theme.palette.primary.dark,
            border: `1.5px solid ${alpha(theme.palette.primary.main, 0.3)}`,
          }}
        />
      ),
    },
    {
      title: 'Text',
      field: 'code1',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rowData.code1 + (rowData.motor ? ` Motor: ${rowData.motor}` : '')}
        </Typography>
      ),
    },
    {
      title: 'Error Code',
      field: 'code2',
      render: (rowData) =>
        rowData.code2 ? (
          <Chip
            label={rowData.code2}
            size="small"
            sx={{
              fontWeight: 600,
              backgroundColor: alpha(theme.palette.error.main, 0.12),
              color: theme.palette.error.dark,
              border: `1.5px solid ${alpha(theme.palette.error.main, 0.3)}`,
            }}
          />
        ) : (
          <Typography variant="body2" color="text.secondary">
            -
          </Typography>
        ),
    },
    {
      title: 'Message',
      field: 'code3',
      render: (rowData) => (
        <Typography variant="body2" sx={{ fontWeight: 500 }}>
          {rowData.code3 || '-'}
        </Typography>
      ),
    },
    {
      title: 'User',
      field: 'user.email',
      render: (rowData) => {
        if (rowData.user) {
          return (
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {rowData?.user?.firstname + ' ' + rowData?.user?.lastname}
            </Typography>
          );
        } else {
          return (
            <Typography variant="body2" color="text.secondary">
              -
            </Typography>
          );
        }
      },
    },
  ];

  useEffect(() => {
    let isCancelled = false;
    if (!NotBothAdmin) {
      async function getGroups() {
        await request({
          method: 'get',
          url: !props.match.params.group && superAdmin ? getGroupsURL : getGroupsURL + userEmail,
        }).then((res) => {
          res.data.machines.forEach((element) => {
            element.product?.forEach((e) => {
              e.id.name = e.id.name.en;
            });
          });
          if (!isCancelled) {
            setGroups(res.data.groups);
            setMachines(res.data.machines);
            setFiltered(res.data.machines);
          }
        });
      }
      getGroups();
    } else {
      request({
        method: 'get',
        url: '/machines/getMyMachines',
      }).then((res) => {
        if (!isCancelled) {
          // console.log(res.data);
          res.data?.forEach((element) => {
            if (element?.status_info === 'Out Of Service') {
              element.oos = 'NO';
            }
            element.online = 'false';
          });

          // setLoading(false);
          setMachines(res.data);
        }
      });
    }

    return () => {
      setMachines([]);
      setGroups([]);
      setLoading(false);
      isCancelled = true;
    };
  }, []);

  const handleStartDate = (e) => {
    setStartDate(e);
  };

  const handleEndDate = (e) => {
    setEndDate(e);
  };

  const handleChange = async (event) => {
    let filteredArray = [];
    setLoading(true);
    let myIDs = 0;
    if (radio == 'a') {
      setFiltered(machines);
      myIDs = machines.map((e) => e._id).join(',');
      setmachinesName('All Machines');
      filteredArray = [...machines];
    }
    if (radio == 'g') {
      const myArray = groupV.map((e) => e.machineID);
      var merged = [].concat.apply([], myArray);
      merged = merged.filter((e, i, self) => i === self.findIndex((t) => t._id == e._id));
      // const filteredArray = machines.filter((e, i) => i == merged.findIndex((t)=>(t._id == e._id)));
      machines.forEach((e) => {
        merged.findIndex((t) => {
          if (t._id == e._id) {
            filteredArray.push(e);
          }
        });
      });
      setFiltered(filteredArray);
      myIDs = filteredArray.map((e) => e._id).join(',');
      setmachinesName(`Groups: ${groupV.map((e) => e.name).join(', ')} `);
    }
    if (radio == 'm') {
      setFiltered(groupV);
      filteredArray = [...groupV];
      myIDs = groupV.map((e) => e._id).join(',');

      setmachinesName(`Machines: ${groupV.map((e) => e.name).join(', ')} `);
    }
    console.log('myIDs', id);
    const { startDateString, endDateString } = localDateRange(startDate, endDate);
    await request({
      method: 'post',
      url: getAlerts,
      data: {
        machineID: myIDs,
        id: id,
        startDate: startDateString,
        endDate: endDateString,
      },
    }).then((res) => {
      console.log('KioskLog', res.data);
      let filteredArray = res.data.filter(
        (e) => e.code1
        // != 'Slot number is not found when try to checkout'
      );
      // setData(res.data);
      setData(filteredArray);
      setLoading(false);
    });
  };

  return (
    <ModernPageContainer>
      {loading && <LoadingIcon />}

      <ModernPageHeader
        title={tableTitle || 'Kiosk Logs'}
        subtitle="View kiosk activity logs and error messages"
        icon={DevicesIcon}
      />

      <Container maxWidth="xl" sx={{ mt: 3, px: 0 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <MachineSelect
              filterd={filterd}
              handleStartDate={handleStartDate}
              handleEndDate={handleEndDate}
              startDate={startDate}
              endDate={endDate}
              setRadio={setRadio}
              setgroupV={setgroupV}
              radio={radio}
              groupV={groupV}
              groups={groups}
              machines={machines}
              handleChange={handleChange}
            />
          </Grid>
        </Grid>
      </Container>

      <Box sx={{ mt: 3 }}>
        <ModernTable
          onRowsPerPageChange={setPagination}
          columns={columns}
          data={data}
          options={{
            actionsColumnIndex: -1,
            pageSize: parseInt(pagination),
            pageSizeOptions: [10, 20, 50, 100, 200],
          }}
        />
      </Box>
    </ModernPageContainer>
  );
}
